
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#070808","d":"M14.242 2.176L12.825.759a1.256 1.256 0 00-.908-.372c-.512 0-.945.276-.993.307a.554.554 0 00-.08.065L2.255 9.424a.491.491 0 00-.11.166c0 .002-.002.003-.003.005l-1.72 4.334a.5.5 0 00.65.649l4.334-1.72a.508.508 0 00.167-.109l8.667-8.593a.414.414 0 00.065-.08c.254-.383.566-1.273-.063-1.9zM5.338 9.279H3.806L9.941 3.09l1.969 1.969-6.072 6.02v-1.3a.5.5 0 00-.5-.5zm-2.392 1h1.892v1.729l-3.06 1.214 1.168-2.943zm10.545-6.788l-.871.863-1.974-1.974.864-.872c.134-.074.455-.197.607-.043l1.418 1.418c.171.171.014.501-.044.608z"}})])
          )
        }
      }
    